import { getConfig } from 'owa-service/lib/config';
import GetAttachmentsAsZipRequest from 'owa-service/lib/contract/GetAttachmentsAsZipRequest';
import ZipAttachmentInfo from 'owa-service/lib/contract/ZipAttachmentInfo';
import getAttachmentsAsZipRequest from 'owa-service/lib/factory/getAttachmentsAsZipRequest';
import zipAttachmentInfo from 'owa-service/lib/factory/zipAttachmentInfo';
import { getParameterStore } from '../store/ParametersStore';
import { MailboxType } from 'owa-client-ids';
import { downloadAttachmentFromUrl } from 'owa-attachment-user-operations';

const MAX_QUERYSTRING_LENGTH: number = 2048;
const DOWNLOAD_ATTACHMENTS_ZIP_URL: string = '/service.svc/s/GetAttachmentsAsZip';

function buildRequest(attachmentsIds: string[], fileName: string): GetAttachmentsAsZipRequest {
    const attachmentsInfo: ZipAttachmentInfo[] = [];
    for (let i = 0; i < attachmentsIds.length; i++) {
        attachmentsInfo.push(zipAttachmentInfo({ AttachmentId: attachmentsIds[i] }));
    }

    return getAttachmentsAsZipRequest({
        ZipFileName: fileName,
        ZipAttachmentsInfo: attachmentsInfo,
    });
}

export function downloadAttachmentsZip(attachmentsIds: string[], fileName: string): boolean {
    const serializedRequest = JSON.stringify(buildRequest(attachmentsIds, fileName));
    const queryString = `jsonRequestData=${encodeURIComponent(serializedRequest)}`;

    const groupString =
        getParameterStore().mailboxInfo.type === MailboxType.GroupMailbox
            ? '/' + getParameterStore().mailboxInfo.primarySmtpAddress
            : '';
    const downloadURL = `${
        getConfig().baseUrl
    }${groupString}${DOWNLOAD_ATTACHMENTS_ZIP_URL}?${queryString}`;

    //TODO: Log usage here

    if (queryString.length < MAX_QUERYSTRING_LENGTH) {
        downloadAttachmentFromUrl(downloadURL, false);
        return true;
    }

    return false;
}
